import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var generateActivityFilters = function generateActivityFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var transform = arguments.length > 1 ? arguments[1] : undefined;
  var rootLevelFilters = arguments.length > 2 ? arguments[2] : undefined;
  return Object.entries(filters).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      filter = _ref2[1];
    var entry = transform ? transform(key, filter) : _defineProperty({}, key, filter);
    return rootLevelFilters !== null && rootLevelFilters !== void 0 && rootLevelFilters.includes(key) ? _objectSpread(_objectSpread({}, acc), entry) : _objectSpread(_objectSpread({}, acc), {}, {
      arguments: _objectSpread(_objectSpread({}, acc.arguments), entry)
    });
  }, {
    type: 'AND',
    arguments: {}
  });
};